import React, { useEffect, useState, useRef } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import CurrencyConverter from "../CurrencyConverter/CurrencyConverter";
import ProviderDetails from "../ProviderDetails/ProviderDetails";
import Loader from "../Common/Loader/Loader";
import ShowDescription from "../ShowDescription/ShowDescription";
import { additionalFeeUserResponseAction } from "../../actions/booking/additionalFeeUserResponseAction";
import { api, toneUploadDir } from "../../config";
import messages from "../../locale/messages";
import bt from '../../components/commonStyle.css';
import s from './AdditionalRequestForm.css';


function AdditionalRequestForm(props) {
    const { id, fee, details, currency, secondDifference, data, intl: { formatMessage }, additionalWorkInterval } = props
    const [play, setPlay] = useState(false)
    const [isTimerActive, setTimerActive] = useState(true)
    const dispatch = useDispatch()
    const audioRef = useRef()
    const togglePlay = () => {
        if (audioRef.current) {
            if (!play) {
                audioRef.current.play();
            } else {
                audioRef.current.pause();
            }
            setPlay(!play);
        }
    }
    useEffect(() => {
        togglePlay()
    }, [])
    const requestTone = useSelector(state => state?.siteSettings?.data?.requestTimeTone)
    const isAdditionalFee = useSelector(state => state.adminModalStatus.formData.isAdditionalFee)
    const approveLoader = useSelector(state => state?.loader?.approveLoader)
    const rejectLoader = useSelector(state => state?.loader?.rejectLoader)

    let timeDiff = (parseFloat(additionalWorkInterval) * 60) - secondDifference;

    const subCategoryNames = data?.orderItemsList
        ?.map(item => item?.subCategoryDetails?.name)
        .filter(name => name)
        .join(', ');

    const handleClick = (status) => {
        setTimerActive(false)
        dispatch(additionalFeeUserResponseAction({ status, bookingId: id }))
    }
    return (
        <div>
            {!isAdditionalFee && <audio id="audio-element" ref={audioRef}>
                <source src={api.apiEndpoint + toneUploadDir + requestTone}></source>
            </audio>}
            <div className={s.additionalRequestTimerContainer}>
                <div className={s.additionalRequestTimerInfo}>
                    <div className={s.additionRequestBookingIdInfoIdBox}>
                        <span className={bt.displayInlineBlock}><FormattedMessage {...messages.idText} /></span>
                        <span className={bt.displayInlineBlock}>&nbsp;#{id}</span>
                    </div>
                    <div className={cx(bt.commonSize14, bt.primaryColor, bt.textAlignStart)}>
                        <span className={cx(bt.commonSize14, bt.fontWeight700, bt.primaryColor, bt.displayInlineBlock)}>
                            <FormattedMessage {...messages.jobTitle} />&nbsp;
                        </span>
                        {subCategoryNames && <span className={cx(bt.fontWeight400)}>{subCategoryNames}</span>}
                    </div>
                </div>
                {!isAdditionalFee && timeDiff > 0 && <div className={s.additionalRequestTimerClock}>
                    <CountdownCircleTimer
                        key={id}
                        isPlaying={isTimerActive}
                        initialRemainingTime={parseInt(timeDiff)}
                        duration={parseFloat(additionalWorkInterval) * 60}
                        trailColor={"#E5E5E5"}
                        colors={['#D32F2F']}
                        size={92}
                        strokeWidth={2}
                        onComplete={async () => {
                            await dispatch(additionalFeeUserResponseAction({ bookingId: id, status: 'rejected' }));

                        }}
                    >
                        {({ remainingTime }) => {
                            return (
                                <>
                                    <span className={s.additionalRequestTimerCount}>{remainingTime}</span>
                                    <sub className={s.additionalRequestTimerSecText}>s</sub>
                                </>
                            )
                        }}
                    </CountdownCircleTimer>
                </div>
                }
            </div>
            <hr className={s.additionalRequestDivider} />
            <div>
                <div className={cx(bt.commonSize18, bt.fontWeight600, bt.primaryColor, bt.textAlignStart, bt.space1)}>
                    <FormattedMessage {...messages.estimatedAdditionalCost} />
                </div>
                <div className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor, bt.textAlignStart)}><CurrencyConverter amount={fee} from={currency} /></div>
            </div>
            <hr className={s.additionalRequestDivider} />
            {details && <div>
                <div className={cx(bt.commonSize18, bt.fontWeight600, bt.primaryColor, bt.textAlignStart, bt.space1)}>
                    <FormattedMessage {...messages.workDetails} />
                </div>
                <ShowDescription description={details} count={250} className={cx(bt.commonSize14, bt.fontWeight400, bt.primaryColor, bt.textAlignStart)} />
                <hr className={s.additionalRequestDivider} />
            </div>
            }
            <div>
                <div className={cx(bt.commonSize18, bt.fontWeight600, bt.primaryColor, bt.textAlignStart, s.additionalRequestHeadingSpace10)}><FormattedMessage {...messages.requestBy} /></div>
                <ProviderDetails noIcons={true} data={data} isAdditionalRequestPopup={true} />
            </div>
            {!isAdditionalFee && <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Loader
                    type={"button"}
                    buttonType={'button'}
                    show={rejectLoader}
                    label={formatMessage(messages.reject)}
                    handleClick={() => handleClick('rejected')}
                    className={cx(bt.btnSecondary, 'loaderButtonFlex')}
                />
                <Loader
                    type={"button"}
                    buttonType={'button'}
                    show={approveLoader}
                    label={formatMessage(messages.accept)}
                    handleClick={() => handleClick('approved')}
                    className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                />
            </div>}

        </div>
    )
}

export default injectIntl(withStyles(bt, s)(AdditionalRequestForm))
